import { Box } from '@mui/material';
import { forwardRef, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react';

type FR<T, P> = ForwardRefExoticComponent<PropsWithoutRef<P> & RefAttributes<T>>;

type Props = {
  size: number;
  tid?: string;
};

export const space: FR<HTMLDivElement, Props> = forwardRef((props, ref) => {
  const { size, tid } = props;
  const normalizedSize = size > 0 ? size : 0;

  return (
    <Box
      ref={ref}
      data-testid={tid}
      sx={{
        width: '100%',
        height: (theme) => theme.spacing(normalizedSize),
        flexShrink: 0,
      }}
    />
  );
});

space.displayName = 'SiloReal-Form-Space';
